'use client';

import React from 'react';
import { BsPencil } from 'react-icons/bs';
import { IoBriefcaseOutline, IoCalendarOutline, IoMapOutline } from 'react-icons/io5';
import { TbBook, TbMail, TbPhoto, TbQrcode } from 'react-icons/tb';

import { VisuallyHidden } from '@mantine/core';

import { Features } from '@marketing/components/features/Features';
import { PageHeader } from '@marketing/components/page-header/PageHeader';
import { SectionSpacer } from '@marketing/components/section/SectionSpacer';

import { MarketingHelpers } from 'helpers/MarketingHelpers';
import { RouterHelpers } from 'helpers/RouterHelpers';

import { ReplusLogo } from 'components/logo/ReplusLogo';

const ResourcesPage = () => {
    return (
        <>
            <PageHeader
                title={
                    <>
                        <ReplusLogo c="white" w={120} />
                        <VisuallyHidden>RE+Source PRO</VisuallyHidden>
                        <br /> Resources
                    </>
                }
                variant="dark"
                bg="purple"
                color="white"
            />

            <SectionSpacer size="sm" />

            <Features
                title="Explore RE+Source PRO Resources"
                description="Access tools, guides, and resources to help you make the most of the RE+Source PRO platform."
            >
                {[
                    {
                        title: 'Upcoming RE+ Events',
                        description: 'Discover upcoming renewable energy events and networking opportunities',
                        icon: <IoCalendarOutline size={24} strokeWidth={1.25} />,
                        action: {
                            label: 'View Events',
                            href: RouterHelpers.urls.events.upcoming(),
                        },
                    },
                    {
                        title: 'Microgrid Case Studies',
                        description: 'Explore real-world microgrid implementations and success stories',
                        icon: <IoBriefcaseOutline size={24} strokeWidth={1.25} />,
                        action: {
                            label: 'Browse Case Studies',
                            href: RouterHelpers.urls.caseStudies(),
                        },
                    },
                    {
                        title: 'Microgrid Reference Designs',
                        description: 'Browse and get inspired by microgrid reference designs',
                        icon: <BsPencil size={24} />,
                        action: {
                            label: 'Browse Designs',
                            href: RouterHelpers.urls.designs.overview(),
                        },
                    },
                    {
                        title: 'DC Microgrid Map',
                        description: 'Explore DC microgrids around the world on an interactive map',
                        icon: <IoMapOutline size={24} strokeWidth={1.25} />,
                        action: {
                            label: 'View Map',
                            href: RouterHelpers.urls.map(),
                        },
                    },
                    {
                        title: 'QR Codes at RE+ Events',
                        description: 'Generate and access QR codes for your company profile at events',
                        icon: <TbQrcode size={24} strokeWidth={1.25} />,
                        action: {
                            label: 'Get QR Code',
                            href: MarketingHelpers.urls.resourcepro.qrCodes(),
                        },
                    },
                    {
                        title: 'Media Toolkit',
                        description: 'Access logos, images, and marketing materials for your company',
                        icon: <TbPhoto size={24} strokeWidth={1.25} />,
                        action: {
                            label: 'View Toolkit',
                            href: MarketingHelpers.urls.resourcepro.mediaToolkit(),
                        },
                    },
                    {
                        title: 'RE+Source PRO Insider',
                        description: 'Stay updated with the latest platform features and news',
                        icon: <TbBook size={24} strokeWidth={1.25} />,
                        action: {
                            label: 'Read Insider',
                            href: '/resourcepro/insider',
                        },
                    },
                    {
                        title: 'Contact RE+Source PRO Support',
                        description: 'Get help from our support team',
                        icon: <TbMail size={24} strokeWidth={1.25} />,
                        action: {
                            label: 'Contact Support',
                            href: 'mailto:support@directenergypartners.com',
                        },
                    },
                ]}
            </Features>

            <SectionSpacer size="lg" />
        </>
    );
};

export default ResourcesPage;
